"use strict";
import i18n from "@/lang";
export default {
  qq: (rule, value, callback) => {
    if (value !== null) {
      let runoob = /^\\d{5,15}$/;
      let search = value.search(runoob);
      if (value !== "" && search < 0) {
        return callback(new Error(i18n.t("validator.qq_tip")));
      }
    }
    return callback();
  },
  phone: (rule, value, callback) => {
    if (value !== null) {
      let runoob = /^1\d{10}$/;
      let search = value.search(runoob);
      if (value !== "" && search < 0) {
        return callback(new Error(i18n.t("validator.phone_tip")));
      }
    }
    return callback();
  },
  USPhone: (rule, value, callback) => {
    if (value !== null) {
      let runoob = /^[2-9]\d{2}[2-9](?!11)\d{6}$/;
      let search = value.search(runoob);
      if (value !== "" && search < 0) {
        return callback(new Error(i18n.t("validator.phone_tip")));
      }
    }
    return callback();
  },
  IndiaPhone: (rule, value, callback) => {
    if (value !== null) {
      let runoob = /^[789]\d{9}$/;
      let search = value.search(runoob);
      if (value !== "" && search < 0) {
        return callback(new Error(i18n.t("validator.phone_tip")));
      }
    }
    return callback();
  },
  PakistanPhone: (rule, value, callback) => {
    if (value !== null) {
      let runoob = /^\d{10}$/;
      let search = value.search(runoob);
      if (value !== "" && search < 0) {
        return callback(new Error(i18n.t("validator.phone_tip")));
      }
    }
    return callback();
  },
  email: (rule, value, callback) => {
    if (value !== null && value !== void 0 && value !== "") {
      let runoob = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      let search = value.search(runoob);
      if (value !== "" && search < 0) {
        return callback(new Error(i18n.t("validator.email_tip")));
      }
    }
    return callback();
  },
  ip: (rule, value, callback) => {
    if (value !== null) {
      let runoob = /((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))/;
      let search = value.search(runoob);
      if (value !== "" && search < 0) {
        return callback(new Error(i18n.t("validator.ip_tip")));
      }
    }
    return callback();
  },
  password: (rule, value, callback) => {
    if (value !== null) {
      let runoob = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,24}$/;
      let search = value.search(runoob);
      if (value !== "" && search < 0) {
        return callback(new Error(i18n.t("register.password_trigger_tip4")));
      }
    }
    return callback();
  },
  url: (rule, value, callback) => {
    if (value !== null) {
      let runoob = /^(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]$/;
      let search = value.search(runoob);
      if (value !== "" && search < 0) {
        return callback(new Error(i18n.t("validator.url_tip")));
      }
    }
    return callback();
  },
  no_empty: (rule, value, callback) => {
    value = value.replace(/(^\s*)|(\s*$)/g, "");
    let message = rule.hasOwnProperty("message") ? rule.message : i18n.t("validator.message_tip");
    if (value === "") {
      return callback(new Error(message));
    }
    return callback();
  }
};
